import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@types+node@20.17.30_eslint@8.57.1_less@4.3.0_rollup@4.39.0_stylelint@14.16.1_typ_eu57e4znwe7lk7fv46o5s3w3zu/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@types+node@20.17.30_eslint@8.57.1_less@4.3.0_rollup@4.39.0_stylelint@14.16.1_typ_eu57e4znwe7lk7fv46o5s3w3zu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}